import { type PropsWithChildren, useState } from 'react';

interface ContentBoxProps {
    header?: string;
}

const ContentBox = ({ header, children }: PropsWithChildren<ContentBoxProps>) => {
    const [open, handleOpen] = useState<boolean>(false);
    return (
        <div className='rounded-xl bg-gray-darkest p-15 shadow-sm'>
            <p
                className={`mb-5 display-flex cursor-pointer align-items-center justify-content-between pb-5 text-bold text-white ${!open && 'border-b border-gray-dark'}`}
                onClick={() => handleOpen(!open)}
            >
                {header}
                <span className={`rioglyph rioglyph-chevron-up ${!open && 'rotate-180'}`} />
            </p>
            <div className={open ? 'display-flex' : 'hidden'}>{children}</div>
        </div>
    );
};

export default ContentBox;
